export const CustomEventParameterTypes = ['text', 'timestamp', 'numeric'] as const
